module.exports = __webpack_public_path__ + "static/img/logo5.416897e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo5.png
// module id = Ux05
// module chunks = 48